import { m } from "~/i18n/messages";
import type { Level } from "~/lib/server/db/schema/flashcard-schema";

type MaterialMetadata = {
	level: Level;
	title: string;
	description: string;
};

export const MATERIAL_METADATA: Record<Level, MaterialMetadata> = {
	n5: {
		level: "n5",
		title: m["jlpt_levels.n5.title"](),
		description: m["jlpt_levels.n5.description"](),
	},
	n4: {
		level: "n4",
		title: m["jlpt_levels.n4.title"](),
		description: m["jlpt_levels.n4.description"](),
	},
	n3: {
		level: "n3",
		title: m["jlpt_levels.n3.title"](),
		description: m["jlpt_levels.n3.description"](),
	},
	n2: {
		level: "n2",
		title: m["jlpt_levels.n2.title"](),
		description: m["jlpt_levels.n2.description"](),
	},
	n1: {
		level: "n1",
		title: m["jlpt_levels.n1.title"](),
		description: m["jlpt_levels.n1.description"](),
	},
};
